import axiosClient from './axiosClient';
import { IParamsGetJobs, IResponseGetJob } from '~/utils/interface/job';
import { IApiBaseResponse } from '~/utils/interface/common';

const jobApi = {
  getJobs(params: IParamsGetJobs) {
    const url = `api/admin/jobs`;
    return axiosClient.get<IApiBaseResponse<IResponseGetJob>>(url, { params });
  },
};

export default jobApi;
